import { getSectionData } from "../utilities/getSectionData";
import { linkOptionSelectors } from "../utilities/linkedSwatchOptions";
import Swiper from "swiper";
import { _addEventListener } from "../utilities/Helpers/eventHelper";
import { selectCallback } from "../utilities/selectCallback";
import { Navigation } from "swiper/modules";
import { blockScroll, unblockScroll } from "../utilities/Helpers/helpers";
import ProductGallery from "../utilities/Product/ProductGallery";
import Modal from "../utilities/Helpers/UI/Modal";
import { hideFocusVisibility, showFocusVisibility } from "../utilities/Helpers/Accesibility/ModalFocusTrapHelper";
import { isDesktop, isTouchScreen } from "../utilities/screenSize";

LUC.jsProduct = {
    productGallery: null,
    init: function (section) {
        require("../utilities/option_selection");
        if (section.classList.contains("product-main")) {
            LUC.jsProduct.openChooseSizeModal();
            LUC.jsProduct.displayImagesGroup();
            LUC.jsProduct.scrollToSection("[data-js-pdp-read-more]", '[data-scroll-to-click="content-desc"]');
            LUC.jsProduct.setStickyATC();
            LUC.jsProduct.bestsellersSliders();
            LUC.jsProduct.triggerNotifyPopup();
            LUC.jsProduct.scrollToReviews();
            LUC.jsProduct.copyLink();
            LUC.jsProduct.registerProductModals();

            //SBL
            LUC.jsProduct.toggleSblContainer();
            LUC.jsProduct.updateSblCollectionPrice();
            LUC.jsProduct.addToCartSblCollection();
            LUC.jsProduct.registerSblModals();
            LUC.jsProduct.scrollableStickyInfoSection();
        }

        //Prevent scrolling on product and closing popups
        if ($("body").hasClass("product")) {
            $("html").css("scroll-behavior", "auto ");
        }

        // Add settings from schema to current object
        LUC.jsProduct = $.extend(this, getSectionData(section));
        $("body").on("click", ".fitguide-menu-link", function (event) {
            event.preventDefault();
            $(".fit-menu-sub-content").removeClass("fit-menu-open");
            $(".fit-guide-menu__list").addClass("fit-menu-active");
            $(".fit-guide-menu__list").addClass("is-closing");

            document
                .querySelectorAll(".fit-guide-menu__list>li>button")
                .forEach((listItem) => hideFocusVisibility(listItem));
            $(this).parent().children(".fit-menu-sub-content").addClass("fit-menu-open");
            showFocusVisibility(this.closest("li").querySelector(".fit-menu-sub-content>button"));
        });
        $("body").on("click", ".fit-menu-back", function (event) {
            event.preventDefault();
            $(this).parent().removeClass("fit-menu-open");
            $(".fit-guide-menu__list").removeClass("fit-menu-active");
            $(".fit-guide-menu__list").removeClass("is-closing");
            document
                .querySelectorAll(".fit-guide-menu__list>li>button")
                .forEach((listItem) => showFocusVisibility(listItem));
        });
        $("body").on("click", ".fit-accordion-title", function (event) {
            event.preventDefault();
            $(this).toggleClass("is-open");
            $(this).siblings().children(".fit-accordion-block-items").toggleClass("is-active");
        });
        $("body").on("click", ".chart-title", function (event) {
            event.preventDefault();
            $(this).toggleClass("is-open");
            $(this).siblings("p").toggleClass("is-active");
        });
        var btn = $(".back-to-top");
        var fit_button = $("[data-fit-guide-button]");
        var fit_guide_container = $(".fit-guide-container");
        var fit_close_btn = $(".close-btn");
        $(".fit-guide-container .fit-menu-sub-content").scroll(function () {
            if ($(".fit-menu-sub-content").scrollTop() > 10) {
                btn.addClass("show");
            } else {
                btn.removeClass("show");
            }
        });
        btn.on("click", function (e) {
            e.preventDefault();
            $(".fit-guide-container .fit-menu-sub-content").animate({ scrollTop: 0 }, "10");
        });
        $(".product_section").append("<div class='fit-overlay'></div>");
        fit_button.on("click", function () {
            fit_guide_container.addClass("is-active");
            $(".swatch-info-wrapper").removeClass("open");
            $(".fit-overlay").addClass("active");
            if ($(document).height() > $(window).height()) {
                $("html").addClass("hidden-scroll");
            }
        });
        fit_close_btn.on("click", function () {
            fit_guide_container.removeClass("is-active");
            $(".fit-overlay").removeClass("active");
            $("html").removeClass("hidden-scroll");
        });
        $(".fit-overlay").on("click", function () {
            $(".swatch-info-wrapper .size-chart-mw").removeClass("open");
            $("html").removeClass("hidden-scroll");
            $(".fit-guide-container").removeClass("is-active");
            $(".fit-overlay").removeClass("active");
            $(".swatch-info-wrapper").removeClass("open");
            $("html").removeClass("hidden-scroll");
        });

        $(window).on("load", function () {
            LUC.jsProduct.mobileAccordion();
            if (
                window.location.hash != "" &&
                $('.product-details-tab a[href = "' + window.location.hash + '"]').length > 0
            ) {
                $(".product-details-tab a").removeClass("active");
                $('.product-details-tab a[href = "' + window.location.hash + '"]').addClass("active");
            }
            $(".product-details-tab a").on("click", function () {
                var hashClick = $(this).prop("hash");
                var href = $(this).attr("href");
                $(".product-details-tab a").removeClass("active");
                if (href === hashClick) {
                    $(this).addClass("active");
                }
            });
        });

        $("[data-product-form-options]", section).each(function () {
            if ($(".select-container").length) {
                new Shopify.OptionSelectors($(this).data("select-id"), {
                    product: $(this).data("product"),
                    onVariantSelected: selectCallback,
                    enableHistoryState: $(this).data("enable-state"),
                });
            }
        });

        if ($(".product-page").hasClass("template-shop-by-look")) {
            this.enableProductSblSwatches();
        } else {
            this.enableProductSwatches();
        }

        // Patch to fix the issue that Fit Guide video still playing after modal is closed
        function stopVideo() {
            var videoWrapper = $(".trial-video-wrapper").find("iframe");
            if (videoWrapper.length) {
                var videoURL = videoWrapper.attr("src").split("?")[0];
                videoWrapper.attr("src", videoURL);
            }
        }

        $(".fit-menu-back").click(function () {
            stopVideo();
        });
        $(".fit-guide-container .close-btn").click(function () {
            stopVideo();
        });
    },
    openProductModal: function (modalName) {
        const productSizeChartBtns = document.querySelectorAll('[data-product-open-modal="' + modalName + '"]');
        productSizeChartBtns.forEach((productSizeChartBtn) => {
            _addEventListener(productSizeChartBtn, "click", (event) => {
                event.preventDefault();
                let productInfoModal = Modal.getModalByName(modalName);
                productInfoModal.delay = 500;
                productInfoModal.onOpened = (modal) => {
                    modal.getModalElement().classList.remove("tw-translate-x-full");
                    blockScroll();
                };
                productInfoModal.onClosing = (modal) => {
                    modal.getModalElement().classList.add("tw-translate-x-full");
                    unblockScroll();
                };
                productInfoModal.show();
            });
        });
    },
    mobileAccordion() {
        $("body").on("click", ".product-details .heading", function () {
            var getdataAttrElem = $(this)
                .siblings(".product-feature-content")
                .children(".content-image")
                .children("img");
            var getdataAttr = getdataAttrElem.attr("data-flickity-lazyload");
            getdataAttrElem.attr("src", getdataAttr);
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".product-feature-content").removeClass("open");
            } else {
                $(".product-details .heading").removeClass("active");
                $(".product-details .product-feature-content").removeClass("open");
                $(this).addClass("active");
                $(this).siblings(".product-feature-content").addClass("open");
                $("html,body").animate(
                    { scrollTop: $(this).offset().top - $(".mobile-logo").outerHeight() - 5 },
                    "slow"
                );
            }
        });
    },
    setCalfCircumferenceValue: function (SizeValue) {
        const calfCircumferenceEl = document.querySelector("[data-js-calf-circumference]");
        if (!calfCircumferenceEl) {
            return;
        }
        const index = "calf_size_" + parseInt(SizeValue, 10);
        if (typeof Shopify.theme_settings[index] !== "undefined") {
            calfCircumferenceEl.innerHTML = Shopify.theme_settings[index] + '"';
        }
    },
    enableProductSwatches: function () {
        // set correct calf circumference based on active size
        const currentSwatchSize = $(".product_section .swatch_options input:checked").val();
        var swatchOption2 = $(".product_section .swatch_options input:checked").eq(1).val() || "";
        var swatchOption3 = $(".product_section .swatch_options input:checked").eq(2).val() || "";
        const selectedSizeEl = document.querySelectorAll('[data-option-value="1"]');
        const selectedWidthEl = document.querySelectorAll('[data-option-value="2"]');
        const selectedToeHeelEl = document.querySelectorAll('[data-option-value="3"]');
        if (!currentSwatchSize) {
            const selectionWrapper = document.querySelectorAll("[data-selected-options]");
            const modalChooseSize = document.querySelector("[data-choose-size-btn]");
            if (selectionWrapper.length > 0) {
                selectionWrapper.forEach((optionWrapper) => {
                    optionWrapper.style.display = "none";
                });
            }
            if (modalChooseSize) {
                modalChooseSize.style.display = "none";
            }

            return;
        }
        if (currentSwatchSize) {
            LUC.jsProduct.setCalfCircumferenceValue(currentSwatchSize);
            LUC.jsProduct.updateOptionValue(selectedSizeEl, currentSwatchSize);
        }
        if (swatchOption2) {
            LUC.jsProduct.updateOptionValue(selectedWidthEl, swatchOption2);
        }
        if (swatchOption3) {
            LUC.jsProduct.updateOptionValue(selectedToeHeelEl, swatchOption3);
            LUC.jsProduct.setToeAndHeelValues(swatchOption3);
        }
        $("body").on("change", ".swatch :radio", function (e) {
            var optionIndex = $(this).closest(".swatch").attr("data-option-index");
            var optionValue = $(this).val();
            var parentForm = $(this).closest(".product_form form");
            LUC.jsProduct.setCalfCircumferenceValue(optionValue);

            var option1 = parentForm.find(".swatch_options input:checked").eq(0).val();
            var option2 = parentForm.find(".swatch_options input:checked").eq(1).val() || "";
            var option3 = parentForm.find(".swatch_options input:checked").eq(2).val() || "";

            if (currentSwatchSize) {
                LUC.jsProduct.updateOptionValue(selectedSizeEl, option1);
            }
            if (swatchOption2) {
                LUC.jsProduct.updateOptionValue(selectedWidthEl, option2);
            }
            if (swatchOption3) {
                LUC.jsProduct.updateOptionValue(selectedToeHeelEl, option3);
                LUC.jsProduct.setToeAndHeelValues(option3);
            }

            $(this).closest("form").find(".single-option-selector").eq(optionIndex).val(optionValue).trigger("change");
        });
        //Swatches linked with selected options
        if ($("[data-product-section]").length) {
            var $productForms = $("[data-product-section]").find(".product_form");
            $productForms.addClass("is-visible");
            //Loop through each product and set the initial option value state
            $productForms.each(function () {
                var JSONData = $(this).data("product");
                var productID = $(this).data("product-id");
                var productSection = ".product-" + productID + " [data-product-section]";
                var swatchOptions = $(this).find(".swatch_options .swatch");
                if (swatchOptions.length > 1) {
                    linkOptionSelectors(JSONData, productSection);
                }
            });
        }
        //Add click event when there is more than one product on the page (eg. Collection in Detail)
        if ($("[data-product-section]").length > 1) {
            $("body").on("click", ".swatch-element", function () {
                var swatchValue = $(this).data("value").toString();
                $(this)
                    .siblings('input[value="' + swatchValue.replace(/"/g, '\\"') + '"]')
                    .prop("checked", true)
                    .trigger("change");
                var JSONData = $(this).parents(".product_form").data("product");
                var productID = $(this).parents(".product_form").data("product-id");
                var productSection = ".product-" + productID + " [data-product-section]";
                var swatchOptions = $(this).parents(".product_form").find(".swatch_options .swatch");
                if (swatchOptions.length > 1) {
                    linkOptionSelectors(JSONData, productSection);
                }
            });
        }
    },
    updateOptionValue: function (optionEl, optionValue) {
        if (optionEl.length > 0) {
            optionEl.forEach((optionWrapper) => {
                optionWrapper.innerHTML = optionValue;
            });
        }
    },
    setToeAndHeelValues: function (option) {
        const toeSizeValue = option.split("+")[0]?.trim();
        const heelSizeValue = option.split("+")[1]?.trim();

        const toeEl = document.querySelector("[data-toe-heel-container] [data-toe-size-label]");
        const heelEl = document.querySelector("[data-toe-heel-container] [data-heel-size-label]");
        if (toeEl) {
            toeEl.dataset.toeSizeLabel = toeSizeValue;
        }
        if (heelEl) {
            heelEl.dataset.heelSizeLabel = heelSizeValue;
        }
        LUC.jsProduct.assignToeHeelThumbnails();
    },
    enableProductSblSwatches: function () {
        // set correct calf circumference based on active size
        const sblProducts = $("[data-sbl-item]");
        sblProducts.each(function () {
            const currentSwatchSize = $(this).find(".swatch_options input:checked").val();
            var swatchOption2 = $(this).find(".swatch_options input:checked").eq(1).val() || "";
            var swatchOption3 = $(this).find(".swatch_options input:checked").eq(2).val() || "";
            const selectedSizeEl = this.querySelector('[data-option-value="1"]');
            const selectedWidthEl = this.querySelector('[data-option-value="2"]');
            const selectedToeHeelEl = this.querySelector('[data-option-value="3"]');
            if (!currentSwatchSize) {
                const selectionWrapper = this.querySelector("[data-selected-options]");
                const modalChooseSize = this.querySelector("[data-choose-size-btn]");
                if (selectionWrapper) {
                    selectionWrapper.style.display = "none";
                }
                if (modalChooseSize) {
                    modalChooseSize.style.display = "none";
                }

                return;
            }
            if (currentSwatchSize) {
                LUC.jsProduct.setCalfCircumferenceValue(currentSwatchSize);
                selectedSizeEl.innerHTML = currentSwatchSize;
            }
            if (swatchOption2) {
                if (selectedWidthEl) {
                    selectedWidthEl.innerHTML = swatchOption2;
                }
            }
            if (swatchOption3) {
                if (selectedToeHeelEl) {
                    selectedToeHeelEl.innerHTML = swatchOption3;
                }
            }
        });
        $("body").on("change", ".swatch :radio", function () {
            var optionIndex = $(this).closest(".swatch").attr("data-option-index");
            var optionValue = $(this).val();
            var parentForm = $(this).closest(".product_form form");
            LUC.jsProduct.setCalfCircumferenceValue(optionValue);

            var option1 = parentForm.find(".swatch_options input:checked").eq(0).val();
            var option2 = parentForm.find(".swatch_options input:checked").eq(1).val() || "";
            var option3 = parentForm.find(".swatch_options input:checked").eq(2).val() || "";
            const selectedSizeEl = parentForm.find('[data-option-value="1"]');
            const selectedWidthEl = parentForm.find('[data-option-value="2"]');
            const selectedToeHeelEl = parentForm.find('[data-option-value="3"]');
            if (option1) {
                if (selectedSizeEl) {
                    selectedSizeEl.html(option1);
                }
            }
            if (option2) {
                if (selectedWidthEl) {
                    selectedWidthEl.html(option2);
                }
            }
            if (option3) {
                if (selectedToeHeelEl) {
                    selectedToeHeelEl.html(option3);
                }
            }

            $(this).closest("form").find(".single-option-selector").eq(optionIndex).val(optionValue).trigger("change");
            LUC.jsProduct.changeSblVariant(parentForm);
            this.closest("[data-sbl-product-handle]").querySelector("[data-sbl-checkbox]").checked =
                this.nextElementSibling.classList.contains("available");
        });
        //Swatches linked with selected options
        if ($("[data-product-section]").length) {
            var $productForms = $("[data-product-section]").find(".product_form");
            $productForms.addClass("is-visible");
            //Loop through each product and set the initial option value state
            $productForms.each(function () {
                var JSONData = $(this).data("product");
                var productID = $(this).data("product-id");
                var productSection = '[data-sbl-product-wrapper="' + productID + '"]';
                var swatchOptions = $(this).find(".swatch_options .swatch");
                if (swatchOptions.length > 1) {
                    linkOptionSelectors(JSONData, productSection);
                }
            });
        }
        //Add click event when there is more than one product on the page (eg. Collection in Detail)
        if ($("[data-product-section]").length > 1) {
            $("body").on("click", ".swatch-element", function () {
                var swatchValue = $(this).data("value").toString();
                $(this)
                    .siblings('input[value="' + swatchValue.replace(/"/g, '\\"') + '"]')
                    .prop("checked", true)
                    .trigger("change");
                var JSONData = $(this).parents(".product_form").data("product");
                var productID = $(this).parents(".product_form").data("product-id");
                var productSection = '[data-sbl-product-wrapper="' + productID + '"]';
                var swatchOptions = $(this).parents(".product_form").find(".swatch_options .swatch");
                if (swatchOptions.length > 1) {
                    linkOptionSelectors(JSONData, productSection);
                }
            });
        }
    },
    setStickyATC: function () {
        const addToCartEl = document.querySelector("[data-js-sticky-atc]");
        const stickyATCBox = document.querySelector("[data-sticky-box]");

        if (!addToCartEl) return;

        let observer = null;

        if (observer) observer.disconnect();

        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        stickyATCBox.classList.remove("atc-sticky");
                    } else {
                        stickyATCBox.classList.add("atc-sticky");
                    }
                });
            },
            {
                root: null,
                threshold: 0,
            }
        );
        observer.observe(addToCartEl);
    },
    openChooseSizeModal: function () {
        const mainBtnEls = document.querySelectorAll("[data-choose-size-btn]");
        if (!mainBtnEls) {
            return;
        }
        mainBtnEls.forEach((mainBtnEl) => {
            mainBtnEl.addEventListener("click", (event) => {
                event.preventDefault();
                const productId = event.target.dataset.chooseSizeBtn;

                const modalChooseSize = Modal.getModalByName("choose-size-" + productId);
                const stickyProductSection = document.querySelector("[data-product-main]");
                LUC.jsProduct.assignToeHeelThumbnails();
                modalChooseSize.onOpened = (modal) => {
                    modal.getModalElement().classList.remove("tw-translate-x-full");
                    blockScroll();
                };
                modalChooseSize.delay = 600;
                modalChooseSize.onClosing = (modal) => {
                    modal.getModalElement().classList.add("tw-translate-x-full");
                    unblockScroll();
                    const stickyProductSection = document.querySelector("[data-product-main]");
                    if (stickyProductSection) {
                        setTimeout(() => {
                            stickyProductSection.style.zIndex = "1";
                        }, 800);
                    }
                };
                modalChooseSize.show();
                LUC.jsProduct.unblockSblVariant(productId);
                if (stickyProductSection) {
                    stickyProductSection.style.zIndex = "10";
                }
            });
        });
    },
    assignToeHeelThumbnails: function () {
        const toeSizeEl = document.querySelector("[data-toe-heel-container] [data-toe-size-label]");
        const heelSizeEl = document.querySelector("[data-toe-heel-container] [data-heel-size-label]");
        if (toeSizeEl) {
            const toeSizeWithBg = document.querySelector('[data-toe-size="' + toeSizeEl.dataset.toeSizeLabel + '"]');
            if (toeSizeWithBg) {
                toeSizeEl.innerHTML = toeSizeWithBg.innerHTML;
            }
        }
        if (heelSizeEl) {
            const heelSizeWithBg = document.querySelector(
                '[data-heel-size="' + heelSizeEl.dataset.heelSizeLabel + '"]'
            );
            if (heelSizeWithBg) {
                heelSizeEl.innerHTML = heelSizeWithBg.innerHTML;
            }
        }
    },
    displayImagesGroup: function () {
        const variantSelector = document.querySelector("[data-variant-selector]");
        let selectedImageGroup = 0;
        let currentGroupId = 0;
        if (variantSelector) {
            selectedImageGroup = variantSelector.options[variantSelector.selectedIndex].dataset.imageId;
            currentGroupId = selectedImageGroup;
        }
        LUC.jsProduct.reInitGalleries(selectedImageGroup);
        $("body").on("change click", ".single-option-selector, label, .swatches .swatch-selector", function () {
            const variantSelector = document.querySelector("[data-variant-selector]");
            const selectedImageGroup = variantSelector.options[variantSelector.selectedIndex].dataset.imageId;
            if (currentGroupId != selectedImageGroup) {
                LUC.jsProduct.reInitGalleries(selectedImageGroup);
                currentGroupId = selectedImageGroup;
            }
        });
    },
    reInitGalleries: function (selectedImageGroup) {
        if (!LUC.jsProduct.productGallery) {
            LUC.jsProduct.productGallery = new ProductGallery("[data-product-gallery-wrapper]");
        }
        if (selectedImageGroup != 0) {
            let galleryMainEl = document.querySelector("[data-pdp-gallery-slider]");
            let galleryThumbsEl = document.querySelector("[data-pdp-gallery-thumbs]");

            galleryThumbsEl.innerHTML = '<div class="swiper-wrapper"></div>';
            const galleryThumbsSlides = document.querySelectorAll(
                '[data-swiper-thumbs-helper] [data-featured-media-id="' + selectedImageGroup + '"]'
            );
            galleryThumbsEl = galleryThumbsEl.querySelector(".swiper-wrapper");
            galleryThumbsSlides.forEach((slide) => {
                galleryThumbsEl.appendChild(slide.cloneNode(true));
            });

            if (LUC.jsProduct.productGallery.initializedGalleries[selectedImageGroup]) {
                galleryMainEl.replaceChild(
                    LUC.jsProduct.productGallery.initializedGalleries[selectedImageGroup],
                    galleryMainEl.querySelector("[data-gallery-content]")
                );
            } else {
                galleryMainEl.innerHTML = '<div data-gallery-content class="swiper-wrapper medium-up:tw-block"></div>';
                const galleryMainSlides = document.querySelectorAll(
                    '[data-swiper-main-helper] [data-featured-media-id="' + selectedImageGroup + '"]'
                );
                galleryMainEl = galleryMainEl.querySelector(".swiper-wrapper");
                galleryMainSlides.forEach((slide) => {
                    galleryMainEl.appendChild(slide);
                });
                LUC.jsProduct.productGallery.initializedGalleries[selectedImageGroup] = galleryMainEl;
            }
            LUC.jsProduct.productGallery.initThumbsSwiper();
            LUC.jsProduct.productGallery.initMainSwiper();

            LUC.jsProduct.productGallery.setVisibilityForDesktop(galleryMainEl);
        }
    },
    bestsellersSliders: function () {
        const slider = document.querySelector(".product__bestsellers [data-pdp-slider-cs]");
        const prevArrow = document.querySelector(".product__bestsellers [data-f-collection-btn-prev]");
        const nextArrow = document.querySelector(".product__bestsellers [data-f-collection-btn-next]");
        const swiperBs = new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1.1,
            spaceBetween: 0,
            centeredSlides: false,
            loop: true,
            autoplay: false,
            allowTouchMove: true,
            navigation: {
                nextEl: nextArrow,
                prevEl: prevArrow,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
            },
        });
    },
    scrollToSection: function (element, tabAccordion) {
        if ($(element).length > 0) {
            $(element).on("click", function (evt) {
                evt.preventDefault();
                if ($(".product-page").hasClass("template-shop-by-look")) {
                    window.location.href = $(evt.target).closest("[data-url]").data("url") + "?reviews=1";
                } else {
                    const descriptionEl = document.querySelector(tabAccordion);
                    if (descriptionEl) {
                        if (!$(tabAccordion).parent().hasClass("active")) {
                            $(tabAccordion).trigger("click");
                        }
                        descriptionEl.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                }
            });
        }
    },
    toggleSblContainer: function () {
        const sblContainerBtn = document.querySelector("[data-sbl-toggle-btn]");
        const sblContainer = document.querySelector("[data-sbl-container]");
        if (!sblContainer) {
            return;
        }
        sblContainerBtn.addEventListener("click", (event) => {
            event.preventDefault();
            sblContainerBtn.classList.toggle("opened");
            if (sblContainerBtn.classList.contains("opened")) {
                $("[data-sbl-container]").slideDown();
            } else {
                $("[data-sbl-container]").slideUp();
            }
        });
    },
    updateSblCollectionPrice: function () {
        const checkboxes = document.querySelectorAll("[data-sbl-checkbox]");
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                LUC.jsProduct.calculateSblPrice();
            });
        });
    },
    calculateSblPrice: function () {
        if (!document.querySelector(".product-page").classList.contains("template-shop-by-look")) {
            return;
        }
        let newPrice = 0;
        const mainPriceEl = document.querySelector("[data-sbl-calculate-price]");
        const mainSblCounter = document.querySelector("[data-sbl-items-count]");
        const mainAddToCartBtn = document.querySelector("[data-sbl-add-to-cart]");
        const activeCheckboxes = document.querySelectorAll("[data-sbl-checkbox]:checked");
        const initialPrice = mainPriceEl.dataset.sblCalculatePrice;
        newPrice = 0;
        if (activeCheckboxes.length > 0) {
            mainAddToCartBtn.style.display = "inline-block";
            mainPriceEl.style.display = "block";
            mainAddToCartBtn.disabled = false;
        } else {
            mainAddToCartBtn.disabled = true;
            mainPriceEl.style.display = "block";
            mainPriceEl.innerHTML = "$" + parseInt(initialPrice / 100);
            mainSblCounter.innerHTML = "0";
        }
        mainSblCounter.innerHTML = activeCheckboxes.length.toString();
        activeCheckboxes.forEach((activeItem) => {
            const priceElement = activeItem.closest("[data-sbl-product-handle]").querySelector("[data-sbl-item-price]");
            if (priceElement) {
                newPrice += parseInt(priceElement.dataset.sblItemPrice);
                mainPriceEl.innerHTML = "$" + parseInt(newPrice / 100);
            }
        });
    },
    addToCartSblCollection: function () {
        const addToCartSblForm = document.querySelector("[data-sbl-collection-form]");
        const atcPayload = document.querySelector("[x-ref=sblAtcPayload]");
        const chooseSizeTriggers = document.querySelectorAll("[data-sbl-product-wrapper] [data-choose-size-btn]");
        if (!chooseSizeTriggers || !atcPayload) {
            return;
        }
        chooseSizeTriggers.forEach((btn) => {
            btn.addEventListener("click", (evt) => {
                let variantsArray = [];
                let isOutOfStockEl = "false";
                const checkboxes = document.querySelectorAll("[data-sbl-checkbox]:checked");
                if (checkboxes) {
                    checkboxes.forEach((item) => {
                        isOutOfStockEl = item.dataset.sblCheckbox;
                        if (isOutOfStockEl !== "false") {
                            const variantId = item.dataset.sblVariantId;
                            const productId = item.dataset.sblProductId;
                            variantsArray.push({ variantId: variantId, productId: productId });
                        }
                    });

                    atcPayload.dataset.payload = JSON.stringify({
                        items: variantsArray.map((variant) => ({ id: variant.variantId, quantity: 1 })),
                    });
                    addToCartSblForm.querySelector("button").disabled = variantsArray.length < 1;
                }
            });
        });
    },
    changeSblVariant: function (parentForm) {
        if (!$(".product-page").hasClass("template-shop-by-look")) {
            return;
        }
        const variantSelector = parentForm.find("[data-variant-selector]");
        const selectedVariant = variantSelector.val();
        const sblCheckboxes = document.querySelectorAll("[data-sbl-checkbox]");
        const productId = variantSelector.data("sbl-main-product-id");
        sblCheckboxes.forEach((item) => {
            if (item.dataset.sblProductId == productId) {
                item.dataset.sblVariantId = selectedVariant;
            }
        });
    },
    // choose variant and unblock add to cart
    unblockSblVariant: function (productId) {
        if (!$(".product-page").hasClass("template-shop-by-look")) {
            return;
        }
        const sblProductWrapper = document.querySelector('[data-sbl-product-wrapper="' + productId + '"]');
        const variantOptionsWrapper = sblProductWrapper.querySelector("[data-selected-options]");
        const variantCheckbox = sblProductWrapper.querySelector("[data-sbl-checkbox]");
        if (variantOptionsWrapper) {
            variantOptionsWrapper.dataset.selectedOptions = true;
        }
        if (variantCheckbox) {
            variantCheckbox.classList.remove("disabled-first");
            if (!variantCheckbox.disabled) {
                variantCheckbox.checked = true;
                LUC.jsProduct.calculateSblPrice();
            }
        }
    },
    triggerNotifyPopup: function () {
        const param = LUC.jsProduct.getURLParameter("notify-me-when-available");
        if (param) {
            setTimeout(() => {
                LUC.jsProduct.openNotifyPopup();
            }, 500);
        }
    },
    openNotifyPopup: function () {
        const notifyKlaviyoPopup = document.querySelector("a.klaviyo-bis-trigger");
        if (notifyKlaviyoPopup) {
            notifyKlaviyoPopup.click();
        }
    },
    scrollToReviews: function () {
        const param = LUC.jsProduct.getURLParameter("reviews");

        function goToReviews() {
            setTimeout(() => {
                const descriptionEl = document.querySelector('[data-scroll-to-click="reviews"]');
                if (descriptionEl) {
                    if (!$('[data-scroll-to-click="reviews"]').parent().hasClass("active")) {
                        $('[data-scroll-to-click="reviews"]').trigger("click");
                    }
                }
            }, 1000);
        }

        if (param) {
            if (document.readyState !== "loading") {
                goToReviews();
            } else {
                document.addEventListener("DOMContentLoaded", goToReviews);
            }
        }
    },
    getURLParameter: function (sParam) {
        const sPageURL = window.location.search.substring(1);
        const sURLVariables = sPageURL.split("&");
        for (let i = 0; i < sURLVariables.length; i++) {
            const sParameterName = sURLVariables[i].split("=");
            if (sParameterName[0] === sParam) {
                return sParameterName[1];
            }
        }

        return false;
    },
    copyLink: function () {
        // Add a trigger for copying the URL
        const copyLink = document.getElementById("copyLink");

        _addEventListener(copyLink, "click", (e) => {
            e.preventDefault();
            const input = document.createElement("input");
            input.value = window.location.href;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
        });
        // Clicking on the Save button will activate Successful Save message

        const successMessage = document.querySelector("[data-success-tooltip]");
        const closeMessage = document.querySelector("[data-close-tooltip]");
        _addEventListener(copyLink, "click", () => {
            successMessage.classList.add("tw-flex");
            successMessage.classList.remove("tw-hidden");
            setTimeout(function () {
                successMessage.classList.remove("tw-flex");
                successMessage.classList.add("tw-hidden");
            }, 15000);
        });
        _addEventListener(closeMessage, "click", () => {
            successMessage.classList.remove("tw-flex");
            successMessage.classList.add("tw-hidden");
        });
    },
    registerProductModals: function () {
        const modals = ["size-chart", "size-info", "width-info", "toe-heel-info", "fit-guide", "dimension-info"];
        modals.forEach((modal) => {
            LUC.jsProduct.openProductModal(modal);
        });
    },
    registerSblModals: function () {
        const sblProducts = document.querySelectorAll("[data-sbl-product-handle]");
        if (sblProducts.length > 0) {
            sblProducts.forEach((sblProduct) => {
                const sblProductHandle = `${sblProduct.dataset.sblProductHandle}-`;
                const modals = [
                    `${sblProductHandle}size-chart`,
                    `${sblProductHandle}size-info`,
                    `${sblProductHandle}width-info`,
                    `${sblProductHandle}toe-heel-info`,
                    `${sblProductHandle}dimension-info`,
                ];
                modals.forEach((modal) => {
                    LUC.jsProduct.openProductModal(modal);
                });
            });
        }
    },
    scrollableStickyInfoSection: function () {
        if (!isDesktop()) {
            console.log("Not desktop");
            return;
        }

        const infoSection = document.querySelector("[data-product-main]");

        const observer = new ResizeObserver((entries) => {
            let infoSection = entries[0].target;
            let infoSectionHeight = infoSection.offsetHeight;
            let viewportHeight = window.innerHeight;
            let calculatedTop = Math.min(viewportHeight - infoSectionHeight, 118);
            infoSection.style.top = `${calculatedTop}px`;
        });

        observer.observe(infoSection);
    },
    unload: function ($section) {},
};
